<template>
  <div class="hello">
    <div  class="head">
      <i :size="20" @click="goIndex" v-loading.fullscreen.lock="fullscreenLoading" class="el-icon-s-home"></i>
         <img class="logo1" src="../../image/logo1.png" alt="" srcset="">
 
   


<i @click="openFullScreen1"
    v-loading.fullscreen.lock="fullscreenLoading" class="el-icon-menu"></i>

    </div>



<el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">home</el-breadcrumb-item>
  <el-breadcrumb-item>List</el-breadcrumb-item>
</el-breadcrumb>



    <div class="ads" ref="ads5"></div>




<div style="    background:rgb(137, 124, 139);
    padding: 7px;
    border-radius: 12px;
    margin: 10px;
">


    <div  class="gameList_te">
      <div  v-for="(item,index) in gameList1" :key="index"  class="game_itme">
        <div  class="game_itme_url" >
            <img @click="goDetail(item)" :src="item.game_img" alt="" srcset="">
        </div>
      </div>
  
    </div>

    </div>



<div class="bottom-btn">
  <a href="javascript:;" @click="goText('/#/privacy')">Privacy Policy</a>
  <a @click="goText('/#/terms')" href="javascript:;">Terms-of Service</a>
  <a style="border-right:none" href="mailto:asking@asking.media">Contact Us</a>
</div>


  </div>
</template>
  
<script>
import   {  getDataList }  from "../../data/gameData_19"
export default {
  name: "HelloWorld",
  data(){
    return{
      dataList: getDataList(),
      gameList1:null,
      fullscreenLoading:false
    }

  },
  props: {
    msg: String,
  },

  created(){
     window.scrollTo(0, 0);
    this.gameList1 = this.swiperList(9)

  },
    mounted() {

   if (localStorage.getItem('Ifgoogl') != 'false') {
// this.loadAds()
}
  },
  methods:{
goText(value){
   window.location.href = value
},

       openFullScreen1() {
        
               window.location.href = `/#/list`
              
  
      },


 loadAds() {
      // 动态插入 Google Ads 代码
      const script = document.createElement('script');
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6372117437285218";
      script.crossorigin = "anonymous"
      script.async = true;
      document.head.appendChild(script);

      // 延迟加载广告
      script.onload = () => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      };

      // 插入广告元素
      const adDiv3 = this.$refs.ads5;
      adDiv3.innerHTML = `
<ins class="adsbygoogle"
     style="display:inline-block;width:300px;height:250px"
     data-ad-client="ca-pub-6372117437285218"
     data-ad-slot="6862635901"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
<\/script>
      `;



    },

swiperList(value) {
  // 在回调函数中使用数据
  var dataCopy = this.dataList.map(element => element);
  var arrNew = [];

  for (var i = 0; i < value; i++) {
    var _num = Math.floor(Math.random() * dataCopy.length);
    var mm = dataCopy[_num];
    // 从复制的数组中移除已选择的元素
    dataCopy.splice(_num, 1);
    arrNew.push(mm);
  }
 
  return arrNew;

  // 这里可以进行后续的同步操作
},


goIndex(){

     
              // this.$router.replace({path:'/'})
                window.location.href = `/#/`
                    
   


},

goDetail(value){
  console.log(this.$router);
  // this.$router.push({path:`/detail?id=${value.id}`})
    window.location.href = `/#/detail?id=${value.id}`
      

},
}
};


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.hello{
  padding-bottom: 50px;
}
.head {
     background: #0d0821;
    padding: 20px;
    display: flex;
    min-height: 30px;
    align-items: center;
    justify-content: space-between;
.home{
  width: 12%;
}
.logo1{
       width: 70%;

}
}
.gameList{
    margin: auto;
    
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
      .game_itme{
        width: 59%;
        margin-bottom: 15px;

        .game_itme_url{
          width: 100%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
        .game_itme_url2{
              width: 30%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
      }
       .game_itme1{
        width: 29%;
        margin-bottom: 15px;

        .game_itme_url{
          width: 100%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
        .game_itme_url2{
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
      }
}
.gameList_te{
    margin: auto;
    
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
      .game_itme{
        width: 28%;
        margin-bottom: 15px;

        .game_itme_url{
          width: 100%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
      }

}

.ads{
  width: 100%;
  min-height: 200px;
}
.About{
    margin-top: 15px;
    text-align: start;
    padding: 20px;
    background: #0d0821;
    color: white;
h2{
  text-align: center;
}
}
.bottom-btn{
      background: #0d0821;
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
a{
      color: #fff;
    font-size: 16px;
        text-decoration: none;
    font-weight: 600;
    border-right: 2px solid #fff;
    padding: 4px;
}
.el-icon-s-home{
       font-size: 3rem;
    color: #ffffff;
}
.el-icon-menu{
     font-size: 3rem;
  color: #ffffff;
}
.el-breadcrumb{
    margin: 20px;
    background: #0d0821;
    display: flex;
    align-items: center;
    border-radius: 11px;
    padding: 15px;
    font-size: 22px;
}
/deep/ .el-breadcrumb__separator{
  color: #ffffff;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner{
    color: #ffffff !important;
}
/deep/ .el-breadcrumb__inner{
     color: #ffffff !important;
}


@media (max-width: 368px) {
  .game_text {
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 2vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
  .el-icon-menu{
    font-size: 4vw; 
  }
  .el-icon-s-home{
     font-size: 4vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 7vw;
  }
}

@media (max-width: 668px) {
  .game_text {
    font-size: 3vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 3vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 3vw; 
  }
    .el-breadcrumb{
     font-size: 3vw; 
  }
    .el-icon-menu{
    font-size: 3vw; 
  }
    .el-icon-s-home{
     font-size: 3vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 7vw;
  }
}


@media (max-width: 768px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 4vw; 
  }
      .el-icon-s-home{
     font-size: 4vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 7vw;
  }
    /deep/ .el-breadcrumb__inner{
     font-size: 7vw;
  }
}


@media (max-width: 900px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 4vw; 
  }
      .el-icon-s-home{
     font-size: 4vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 4vw;
  }
    /deep/ .el-breadcrumb__inner{
     font-size: 4vw;
  }
}


@media (max-width: 1000px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
  .el-breadcrumb{
     font-size: 2vw; 
  }
    .el-icon-menu{
    font-size: 9vw; 
  }
      .el-icon-s-home{
     font-size: 9vw;
  }
    /deep/ .el-breadcrumb__separator{
    font-size: 4vw;
  }
    /deep/ .el-breadcrumb__inner{
     font-size: 4vw;
  }
}


@media (min-width: 1200px) {
  .game_text {
    font-size: 2vw; /* 在PC端显示时调整文字大小 */
  }
    .game_name{
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
  .play{
    font-size: 2vw; 
  }
    .el-icon-menu{
    font-size: 7vw; 
  }
      .el-icon-s-home{
     font-size: 7vw;
  }
  /deep/ .el-breadcrumb__separator{
    font-size: 3vw;
  }
  /deep/ .el-breadcrumb__inner{
     font-size: 3vw;
  }
  .go{
       font-size: 3vw;
  }
}
</style>
